export default "__VITE_ASSET__Dp8WI_Qs__"